// extracted by mini-css-extract-plugin
module.exports = {"Card":"EventCard_Card__S7WES","CardSelected":"EventCard_CardSelected__2JZ9s","CardMedium":"EventCard_CardMedium__sehWg","CardHigh":"EventCard_CardHigh__1OGPv"};